import { dayjs } from "neetocommons/utils";
import { Profile } from "neetoteam";
import { Button, DatePicker, Typography } from "neetoui";
import { Trans, useTranslation } from "react-i18next";

import { DATE_FORMAT, TIME_FORMAT } from "./constants";
import { disabledDate, disabledTime } from "./utils";

const Form = ({ datetimeValue, setDatetimeValue, onClose }) => {
  const { t } = useTranslation();
  const [_, setIsProfilePaneOpen] = Profile.usePaneState();

  return (
    <div className="flex flex-col gap-y-1">
      <DatePicker
        {...{ disabledDate }}
        required
        showTime
        allowClear={false}
        data-testid="publish-later-datepicker-input-field"
        dateFormat={DATE_FORMAT}
        label={t("neetoMolecules.publishBlock.dateTime")}
        timeFormat={TIME_FORMAT}
        value={datetimeValue}
        timePickerProps={{
          "data-testid": "publish-later-timepicker-input-field",
          clearIcon: false,
          disabledTime,
        }}
        onChange={date => {
          setDatetimeValue(date.startOf("hour"));
        }}
      />
      <Typography style="body3">
        <Trans
          i18nKey="neetoMolecules.publishBlock.timezoneDescription"
          values={{ timezone: globalProps.user?.timeZone ?? dayjs.tz.guess() }}
          components={{
            button: (
              <Button
                size="small"
                style="link"
                onClick={() => {
                  onClose();
                  setIsProfilePaneOpen(true);
                }}
              />
            ),
          }}
        />
      </Typography>
    </div>
  );
};
export default Form;
